module.exports = __webpack_public_path__ + "static/computility.3e6cac18.png";